import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import {
	faCar,
	faEdit,
	faGasPump,
	faWarehouse,
	faTachometerAlt,
	faChartBar,
	faListAlt,
	faTag,
	faGavel,
	faCartPlus,
	faAmbulance,
	faUser,
	faLandmark,
	faUsers,
	faHandshake,
	faFileAlt,
	faUserPlus,
	faTasks,
	faTruck,
	faShoppingBasket,
	faShoppingCart,
	faTools,
	faReceipt,
	faExclamationCircle,
	faShareSquare,
	faInbox,
	faPlusCircle,
} from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../contexts/auth';

import LoadingScreen from '../components/LoadingScreen';
import AppTopbar from '../components/PageHeader/PageHeader';
import AppMenu from '../components/SideMenu';
import AppProfile from '../components/ProfileField';

import VehicleList from '../pages/Vehicles/VehiclesList';
import CreateVehicle from '../pages/Vehicles/VehiclesForm';
import CreateAbastecimento from '../pages/Demands/AbastecimentoForm';
import CategoriesList from '../pages/Category/CategoriesList';
import CartaosList from '../pages/Cartao/CartaosList';
import CategoryForm from '../pages/Category/CategoriesForm';
import MileagesList from 'src/pages/Mileages/MileagesList';
import MileageForm from 'src/pages/Mileages/MileagesForm';
import BrandsList from 'src/pages/Brands/BrandsList';
import BrandForm from 'src/pages/Brands/BrandsForm';
import StocksList from 'src/pages/Stocks/StocksList';
import StockForm from 'src/pages/Stocks/StocksForm';
import FuelTypesList from 'src/pages/FuelType/FuelTypesList';
import FuelTypeForm from 'src/pages/FuelType/FuelTypesForm';
import BiddingForm from 'src/pages/Bidding/BiddingsForm';
import ProductForm from 'src/pages/Products/ProductForm';
import DriversList from 'src/pages/Driver/DriversList';
import DriverForm from 'src/pages/Driver/DriversForm';
import ProductsList from 'src/pages/Products/ProductsList';
import AgencyForm from 'src/pages/Agencys/AgencyForm';
import AgencysList from 'src/pages/Agencys/AgencysList';
import UnityForm from 'src/pages/Unitys/UnityForm';
import UnitysList from 'src/pages/Unitys/UnitysList';
import PeopleForm from 'src/pages/People/PeopleForm';
import UnityPeoplesList from 'src/pages/People/UnityPeopleList';
import AgencyPeoplesList from 'src/pages/People/AgencyPeopleList';
import CreditorForm from 'src/pages/Creditor/CreditorsForm';
import NegocioForm from 'src/pages/Negocio/NegociosForm';
import ContratoForm from 'src/pages/Contrato/ContratosForm';
import CreditorsList from 'src/pages/Creditor/CreditorsList';
import NegociosList from 'src/pages/Negocio/NegociosList';
import PageFooter from 'src/components/PageFooter/PageFooter';
import UserForm from 'src/pages/User/UserForm';
import UserList from '../pages/User/UserList';
import FleetInventoryReport from 'src/pages/DataReports/Fleet/FleetInventoryReport';
import FleetExpenditureReport from 'src/pages/DataReports/Fleet/FleetExpenditureReport';
import MaintanenceReport from 'src/pages/DataReports/Maintanence/MaintanenceReport';
import PeopleReport from 'src/pages/People/PeopleReport';
import CheckListForm from 'src/pages/CheckList/CheckListForm';
import StatusList from 'src/pages/Status/StatusList';
import StatusForm from 'src/pages/Status/StatusForm';
import EspecieList from 'src/pages/Especie/EspecieList';
import EspecieForm from 'src/pages/Especie/EspecieForm';
import ProductBrandsList from 'src/pages/ProductBrands/ProductBrandsList';
import ProductBrandForm from 'src/pages/ProductBrands/ProductBrandsForm';
import ProductGroupsList from 'src/pages/ProductGroup/ProductGroupsList';
import ProductGroupForm from 'src/pages/ProductGroup/ProductGroupsForm';
import ProductSubgroupsList from 'src/pages/ProductSubgroup/ProductSubgroupsList';
import ProductSubgroupForm from 'src/pages/ProductSubgroup/ProductSubgroupsForm';
import UnityContractForm from 'src/pages/UnityContract/UnityContractForm';
import BiddingsList from 'src/pages/Bidding/BiddingsList';
import FleetAdminDashboard from 'src/pages/Dashboard/FleetAdmin/FleetAdminDashboard';
import VehiclesListMovimentation from 'src/pages/Movimentations/VehiclesList';
import VehicleMovimentations from 'src/pages/Movimentations/VehicleMovimentations';
import DemandForm from 'src/pages/Demands/DemandForm';
import ReceivedDemandsList from 'src/pages/Demands/ReceivedDemandsList';
import SendedDemandsList from 'src/pages/Demands/SendedDemandsList';
import CartaoForm from 'src/pages/Cartao/CartaosForm';
import AbastecimentoList from 'src/pages/Demands/AbastecimentoList';
import ContratosList from 'src/pages/Contrato/ContratosList';
import ContratosSaldo from 'src/pages/Contrato/ContratosSaldo';
import FaturasList from 'src/pages/Fatura/FaturasList';

const AppRoutes: React.FC = () => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [layoutMode, setLayoutMode] = useState('static');
	const [staticMenuInactive, setStaticMenuInactive] = useState(false);
	const [overlayMenuActive, setOverlayMenuActive] = useState(false);
	const [mobileMenuActive, setMobileMenuActive] = useState(false);
	const [menuClick, setMenuClick] = useState(false);

	const addClass = (element: HTMLElement, className: string) => {
		if (element.classList) element.classList.add(className);
		else element.className += ' ' + className;
	};

	const removeClass = (element: HTMLElement, className: string) => {
		if (element.classList) element.classList.remove(className);
		else
			element.className = element.className.replace(
				new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
				' ',
			);
	};

	useEffect(() => {
		if (mobileMenuActive) addClass(document.body, 'body-overflow-hidden');
		else removeClass(document.body, 'body-overflow-hidden');
		if (isDesktop()) {
			setMobileMenuActive(false);
		} else {
			setStaticMenuInactive(false);
		}
	}, [mobileMenuActive]);

	function isDesktop() {
		return window.innerWidth > 1024;
	}

	function onWrapperClick() {
		if (!menuClick) {
			setOverlayMenuActive(false);
		}
		setMenuClick(false);
	}

	function onToggleMenu() {
		if (isDesktop()) {
			if (layoutMode === 'overlay') {
				setOverlayMenuActive(!overlayMenuActive);
			} else if (layoutMode === 'static') {
				setStaticMenuInactive(!staticMenuInactive);
			}
		} else {
			setMobileMenuActive(!mobileMenuActive);
		}
	}

	function onSidebarClick() {
		setMenuClick(true);
	}

	function onMenuItemClick(event: any) {
		if (!event.item.menuItems) {
			setOverlayMenuActive(false);
			setMobileMenuActive(false);
		}
	}

	function isSidebarVisible() {
		if (isDesktop()) {
			if (layoutMode === 'static') {
				return !staticMenuInactive;
			} else if (layoutMode === 'overlay') return overlayMenuActive;
			else return !staticMenuInactive;
		} else {
			return true;
		}
	}

	const { loading } = useAuth();

	if (loading) {
		return <LoadingScreen />;
	}

	const menu = [
		{ label: 'Dashboard', icon: faChartBar, to: '/dashboard' },
		{
			label: 'Cadastros',
			icon: faEdit,
			menuItem: [
				{
					label: 'Frota',
					icon: faAmbulance,
					menuItem: [
						{ label: 'Veículo', icon: faCar, to: '/listVehicles' },
						{ label: 'Categoria', icon: faListAlt, to: '/listCategories' },
						{ label: 'Espécie de veículo', icon: faTruck, to: '/listEspecies' },
						{ label: 'Tipo de quilometragem', icon: faTachometerAlt, to: '/listMileages' },
						{ label: 'Marca', icon: faTag, to: '/listBrands' },
						{ label: 'Unidades', icon: faLandmark, to: '/listUnitys' },
						{ label: 'Estoque', icon: faWarehouse, to: '/listStocks' },
						{ label: 'Tipo de combustivel', icon: faGasPump, to: '/listFueltypes' },
						{ label: 'Checklist', icon: faTasks, to: '/checklists' },
						{ label: 'Motorista', icon: faUser, to: '/listDrivers' },
						{ label: 'Cartões', icon: faUser, to: '/listCartaos' },
					],
				},
				{ label: 'Licitação', icon: faGavel, to: '/listBidding' },
				{
					label: 'Produtos',
					icon: faCartPlus,
					menuItem: [
						{ label: 'Produtos', icon: faShoppingCart, to: '/listProducts' },
						{ label: 'Grupo de Produtos', icon: faShoppingBasket, to: '/listProductGroups' },
						{ label: 'Subgrupo de Produtos', icon: faShoppingBasket, to: '/listProductSubgroups' },
						{ label: 'Marca de Produtos', icon: faTag, to: '/listProductBrands' },
					],
				},
				{ label: 'Credores', icon: faHandshake, to: '/listCreditors' },
				{ label: 'Negocios', icon: faHandshake, to: '/listNegocios' },
				{ label: 'Contrato', icon: faHandshake, to: '/listContratos' },
				{ label: 'Saldo de Contratos', icon: faHandshake, to: '/saldoContratos' },
				{ label: 'Órgão', icon: faLandmark, to: '/listAgencys' },
				{ label: 'Pessoal', icon: faUsers, to: '/listAgencyPeoples' },
				{ label: 'Usuários', icon: faUserPlus, to: '/listUser' },
			],
		},
		{
			label: 'Relatórios',
			icon: faFileAlt,
			menuItem: [
				{
					label: 'Frota',
					icon: faCar,
					menuItem: [
						{ label: 'Inventário', icon: faWarehouse, to: '/fleetInventoryReport' },
						{ label: 'Consumo', icon: faGasPump, to: '/fleetExpenditureReport' },
					],
				},
				// { label: 'Pessoal', icon: faUser, to: '/peopleReport' },
				{ label: 'Manutenções', icon: faTools, to: '/maintanenceReport' },
			],
		},
		{
			label: 'Fatura',
			icon: faExclamationCircle,
			to: '/FaturaList',
		},
		{
			label: 'Demandas',
			icon: faExclamationCircle,
			menuItem: [
				{ label: 'Nova demanda', icon: faPlusCircle, to: '/DemandForm' },
				{ label: 'Recebidas', icon: faInbox, to: '/listReceivedsDemands' },
				{ label: 'Enviadas', icon: faShareSquare, to: '/listSendedsDemands' },
				{ label: 'Abastecimento', icon: faShareSquare, to: '/listAbastecimento' },
			],
		},
		{ label: 'Movimentações', icon: faReceipt, to: '/vehiclesListMovimentation' },
	];

	const wrapperClass = classNames('layout-wrapper', {
		'layout-overlay': layoutMode === 'overlay',
		'layout-static': layoutMode === 'static',
		'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
		'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
		'layout-mobile-sidebar-active': mobileMenuActive,
	});

	return (
		<div className={wrapperClass} onClick={onWrapperClick}>
			<AppTopbar onToggleMenu={onToggleMenu} />

			<CSSTransition
				classNames='layout-sidebar'
				timeout={{ enter: 200, exit: 200 }}
				in={isSidebarVisible()}
				unmountOnExit>
				<div className='layout-sidebar layout-sidebar-dark' onClick={onSidebarClick}>
					<AppProfile />
					<AppMenu model={menu} onMenuItemClick={onMenuItemClick} />
				</div>
			</CSSTransition>

			<div className='layout-main'>
				<Route path='/dashboard' exact component={FleetAdminDashboard} />
				<Route path='/listBidding' exact component={BiddingsList} />
				<Route path='/biddingForm' exact component={BiddingForm} />
				<Route path='/contractForm' exact component={UnityContractForm} />
				<Route path='/listVehicles' exact component={VehicleList} />
				<Route path='/vehicleForm' exact component={CreateVehicle} />
				<Route path='/listCategories' exact component={CategoriesList} />
				<Route path='/categoryForm' exact component={CategoryForm} />
				<Route path='/listCartaos' exact component={CartaosList} />
				<Route path='/cartaoForm' exact component={CartaoForm} />
				<Route path='/listMileages' exact component={MileagesList} />
				<Route path='/mileageForm' exact component={MileageForm} />
				<Route path='/listBrands' exact component={BrandsList} />
				<Route path='/brandForm' exact component={BrandForm} />
				<Route path='/listEspecies' exact component={EspecieList} />
				<Route path='/especieForm' exact component={EspecieForm} />
				<Route path='/listStocks' exact component={StocksList} />
				<Route path='/stockForm' exact component={StockForm} />
				<Route path='/listStatus' exact component={StatusList} />
				<Route path='/statusForm' exact component={StatusForm} />
				<Route path='/listFueltypes' exact component={FuelTypesList} />
				<Route path='/fueltypeForm' exact component={FuelTypeForm} />
				<Route path='/listProducts' exact component={ProductsList} />
				<Route path='/productForm' exact component={ProductForm} />
				<Route path='/listCreditors' exact component={CreditorsList} />
				<Route path='/listNegocios' exact component={NegociosList} />
				<Route path='/listContratos' exact component={ContratosList} />
				<Route path='/saldoContratos' exact component={ContratosSaldo} />
				<Route path='/creditorForm' exact component={CreditorForm} />
				<Route path='/negocioForm' exact component={NegocioForm} />
				<Route path='/contratoForm' exact component={ContratoForm} />
				<Route path='/listDrivers' exact component={DriversList} />
				<Route path='/driverForm' exact component={DriverForm} />
				<Route path='/listAgencys' exact component={AgencysList} />
				<Route path='/agencyForm' exact component={AgencyForm} />
				<Route path='/listUnitys' exact component={UnitysList} />
				<Route path='/unityForm' exact component={UnityForm} />
				<Route path='/listUnityPeoples' exact component={UnityPeoplesList} />
				<Route path='/listAgencyPeoples' exact component={AgencyPeoplesList} />
				<Route path='/peopleForm' exact component={PeopleForm} />
				<Route path='/listUser' exact component={UserList} />
				<Route path='/userForm' exact component={UserForm} />
				<Route path='/listProductBrands' exact component={ProductBrandsList} />
				<Route path='/productBrandForm' exact component={ProductBrandForm} />
				<Route path='/listProductGroups' exact component={ProductGroupsList} />
				<Route path='/productGroupForm' exact component={ProductGroupForm} />
				<Route path='/listProductSubgroups' exact component={ProductSubgroupsList} />
				<Route path='/productSubgroupForm' exact component={ProductSubgroupForm} />
				<Route path='/checklists' exact component={CheckListForm} />
				<Route path='/fleetInventoryReport' exact component={FleetInventoryReport} />
				<Route path='/fleetExpenditureReport' exact component={FleetExpenditureReport} />
				<Route path='/peopleReport' exact component={PeopleReport} />
				<Route path='/maintanenceReport' exact component={MaintanenceReport} />
				<Route path='/vehiclesListMovimentation' exact component={VehiclesListMovimentation} />
				<Route path='/vehicleMovimentations' exact component={VehicleMovimentations} />
				<Route path='/productForm' exact component={ProductForm} />
				<Route path='/DemandForm' exact component={DemandForm} />
				<Route path='/FaturaList' exact component={FaturasList} />
				
				<Route path='/listReceivedsDemands' exact component={ReceivedDemandsList} />
				<Route path='/listAbastecimento' exact component={AbastecimentoList} />
				<Route path='/listSendedsDemands' exact component={SendedDemandsList} />
				<Route path='/abastecimentoForm' exact component={CreateAbastecimento} />


				<PageFooter />
			</div>

			<div className='layout-mask'></div>
		</div>
	);
};

export default AppRoutes;
